import React from "react";

function Index() {
  return (
    <div className="container mx-auto px-2 w-full max-w-max lg:max-w-max lg:px-4 py-8">
      <div className="lg:max-w-4xl mx-auto bg-white p-6 shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold text-center mb-6">Privacy Policy</h1>
        <>
          <h1>
            <strong>Privacy Policy</strong>
          </h1>
          <p className="py-2">
            Prepits Inc. (<strong>“Company”</strong> or <strong>“We”</strong>)
            respect your privacy and are committed to protecting it by complying
            with this policy.
          </p>
          <p className="py-2">This policy describes:</p>
          <ul className="mt-4 mb-4">
            <li className="ml-4">
              {" "}
              - How we collect, use, disclose, and protect the personal
              information of our customers and website users (
              <strong>“you”</strong>) that utilize the Services.
            </li>
            <li className="ml-4">
              {" "}
              - Describes the types of information we may collect from you or
              that you may provide when you visit the website
              <br />
              <a className="font-semibold" href="https://prepitapp.com">
                https://prepitapp.com
              </a>{" "}
              <br />
              (our <strong>“Website”</strong>) or download, install, register
              with, access, or use the Prepit App (the <strong>“App”</strong>,
              and collectively with the Website the <strong>“Services”</strong>
              ).
            </li>
            <li className="ml-4">
              {" "}
              - Our practices for collecting, using, maintaining, protecting,
              and disclosing that information.
            </li>
          </ul>
          <p className="py-2">
            We will only use your personal information in accordance with this
            policy unless otherwise required by applicable law. We take steps to
            ensure that the personal information that we collect about you is
            adequate, relevant, not excessive, and used for limited purposes.
          </p>
          <p className="py-2">
            Privacy laws in Canada generally define “personal information” as
            any information about an identifiable individual, which includes
            information that can be used on its own or with other information to
            identify, contact, or locate a single person. Personal information
            does not include business contact information, including your name,
            title, or business contact information.
          </p>
          <p className="py-2">
            This policy applies to information we collect, use, or disclose
            about you:
          </p>
          <ul className="mt-4 mb-4">
            <li className="ml-4"> - On this Website.</li>
            <li className="ml-4">
              {" "}
              - In email, text, and other electronic messages between you and
              this Website.
            </li>
            <li className="ml-4"> - Through the App.</li>
            <li className="ml-4">
              {" "}
              - When you interact with our advertising and applications on
              third-party websites and services if those applications or
              advertising include links to this policy.
            </li>
          </ul>
          <p className="py-2">
            The Services may include links to third-party websites, plug-ins,
            services, social networks, or applications. Clicking on those links
            or enabling those connections may allow the third party to collect
            or share data about you. If you follow a link to a third-party
            website or engage a third-party plugin, please note that these third
            parties have their own privacy policies and we do not accept any
            responsibility or liability for these policies. We do not control
            these third-party websites, and we encourage you to read the privacy
            policy of every website you visit. Please read this policy carefully
            to understand our policies and practices for collecting, processing,
            and storing your information. If you do not agree with our policies
            and practices, your choice is not to use our Services. By accessing
            or using the Services, you indicate that you understand, accept, and
            consent to the practices described in this policy. This policy may
            change from time to time. Your continued use of the Services after
            we make changes indicates that you accept and consent to those
            changes, so please check the policy periodically for updates
          </p>
          <h4 className="mt-6 mb-4">
            <strong>INFORMATION WE COLLECT ABOUT YOU</strong>
          </h4>
          <p className="py-2">
            We collect and use several types of information from and about you,
            including:
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Personal information</strong>
          </h4>
          <p className="py-2">
            That we can reasonably use to directly or indirectly identify you,
            such as your name, email address, mailing address, phone number,
            Instagram user ID, website URL, and any other identifier we may use
            to contact you (“personal information”). We provide an opportunity
            for any user to unsubscribe from our Services or opt-out of contact
            for marketing purposes on an ongoing basis by e-mailing
            <br />
            info@prepitapp.com.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Non-personal information</strong>
          </h4>
          <p className="py-2">
            That does not directly or indirectly reveal your identity or
            directly relate to an identifiable individual, such as demographic
            information, or statistical or aggregated information. Statistical
            or aggregated data does not directly identify a specific person, but
            we may derive non-personal statistical or aggregated data from
            personal information. For example, we may aggregate personal
            information to calculate the percentage of users accessing a
            specific Services feature.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Technical information</strong>
          </h4>
          <p className="py-2">
            Including your login information, browser type and version, time
            zone setting, browser plug-in types and versions, operating system
            and platform, or information about your internet connection, the
            equipment you use to access our Services, and usage details.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>
              Non-personal details about your Services interactions
            </strong>
          </h4>
          <p className="py-2">
            Including the full Uniform Resource Locators (URLs), clickstream to,
            through and from our Services (including date and time), pages you
            viewed or searched for, page response times, download errors, length
            of visits to certain
            <br />
            pages, page interaction information (such as scrolling, clicks, and
            <br />
            mouse-overs), methods used to browse away from the page, or any
            phone
            <br />
            number used to call our customer service number.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>HOW WE COLLECT INFORMATION ABOUT YOU</strong>
          </h4>
          <p className="py-2">
            We use different methods to collect your information, including
            through:
          </p>
          <h4 className="mt-6 mb-4">
            <strong>
              Direct interactions with you when you provide it to us,
            </strong>
          </h4>
          <p className="py-2">
            for example, by filling in forms, surveys, or corresponding with us
            by
            <br />
            phone, email, or otherwise.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>User contributions.</strong>
          </h4>
          <p className="py-2">
            You may also provide information for us to
            <br />
            publish or display on public Service areas or transmit to other
            Service
            <br />
            users or third parties.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Automated technologies or interactions,</strong>
          </h4>
          <p className="py-2">
            As you navigate through our Services. Information collected
            automatically may include usage details, IP addresses, and
            information collected through cookies, web beacons, and other
            tracking technologies.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Information You Provide to Us</strong>
          </h4>
          <p className="py-2">
            The information we collect directly from you on or through our
            <br />
            Services may include:
          </p>
          <ul className="mt-4 mb-4">
            <li className="ml-4">
              {" "}
              - Information that you provide by filling in forms through our
              Services.
              <br />
              This includes information provided at the time of registering to
              use
              <br />
              our Services, posting materials, or requesting further services.
              We
              <br />
              may also ask you for information when you report a problem with
              our
              <br />
              Services.
            </li>
            <li className="ml-4">
              {" "}
              - Records and copies of your correspondence (including email
              addresses)
              <br />
              if you contact us.
            </li>
            <li className="ml-4">
              {" "}
              - Your responses to surveys that we might ask you to complete for
              <br />
              research purposes.
            </li>
            <li className="ml-4">
              {" "}
              - Details of transactions you carry out through our Services and
              of the
              <br />
              fulfillment of your orders, including order customizations, failed
              or
              <br />
              incomplete orders, and order size. You may be required to provide
              <br />
              financial information before placing an order through our
              Services.
            </li>
            <li className="ml-4">
              {" "}
              - Your search queries through the Services.
            </li>
          </ul>
          <p className="py-2">
            <br />
            Information We Collect Through Cookies and Other Automatic Data
            Collection Technologies
          </p>
          <p className="py-2">
            As you navigate through and interact with our Services, we may use
            cookies or other automatic data collection technologies to collect
            certain information about your equipment, browsing actions, and
            patterns,
            <br />
            including:
          </p>
          <ul className="mt-4 mb-4">
            <li className="ml-4">
              {" "}
              - Details of your use of our Services, including traffic data,
              location data, and other communication data and the resources that
              you access and use on through our Services.
            </li>
            <li className="ml-4">
              {" "}
              - Information about your computer and internet connection,
              including your IP address, operating system, and browser type. We
              may also use these technologies to collect information about your
              online activities over time and across third-party websites or
              other online services (behavioral tracking). To learn more or to
              opt-out of tailored advertising please visit Digital Advertising
              Alliance of Canada Opt-Out Tool for information on how you can opt
              out of behavioral tracking on the Services and how we respond to
              web browser signals and other mechanisms that enable consumers to
              exercise choice about behavioral tracking. The information we
              collect automatically is statistical information that may include
              personal information], and we may maintain it or associate it with
              personal information we collect in other ways, that you provide to
              us, or receive from third parties. It helps us to improve our
              Services and to deliver a better and more personalized service,
              including by enabling us to:
            </li>
            <li className="ml-4">
              {" "}
              - Estimate our audience size and usage patterns.
            </li>
            <li className="ml-4">
              {" "}
              - Store information about your preferences, allowing us to
              customize our
              <br />
              Services according to your individual interests.
            </li>
            <li className="ml-4"> - Speed up your searches.</li>
            <li className="ml-4">
              {" "}
              - Recognize you when you return to use our Services.
            </li>
          </ul>
          <p className="py-2">
            The technologies we use for this automatic data collection may
            include:
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Cookies (or browser cookies)</strong>
          </h4>
          <p className="py-2">
            A cookie is a small file placed on the hard drive of your computer.
            You may refuse to accept browser cookies by activating the
            appropriate setting on your browser. However, if you select this
            setting you may be unable to access certain parts of our Services.
            Unless you have adjusted your browser setting so that it will refuse
            cookies, our system will issue cookies when you direct your browser
            to our Services.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Web Beacons.</strong>
          </h4>
          <p className="py-2">
            Pages of our Services may contain small electronic files known as
            web beacons (also referred to as clear gifs, pixel tags, and
            single-pixel gifs) that permit the Company, for example, to count
            users who have visited those pages and for other related statistics
            (for example, recording the popularity of certain content and
            verifying system and server integrity).
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Matomo</strong>
          </h4>
          <p className="py-2">
            We use Matomo in order to better understand our users’ needs and to
            optimize our Services. Matomo is a technology service that helps us
            better understand our users’ experience (e.g. how much time they
            spend on which pages, which links they choose to click, what users
            do and don’t like, etc.) and this enables us to build and maintain
            our service with user feedback. Matomo uses cookies and other
            technologies to collect data on our users’ behavior and their
            devices. This includes a device’s IP address (processed during your
            session and stored in a de-identified form), device screen size,
            device type (unique device identifiers), browser information,
            geographic location (country only), and the preferred language used
            to display our website. Matomo stores this information on our behalf
            in a pseudonymized user profile. Matomo is contractually forbidden
            to sell any of the data collected on our behalf.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>
              Third Party Use of Cookies and Other Tracking Technologies
            </strong>
          </h4>
          <p className="py-2">
            Some content or applications on the Website, including
            advertisements, are served by third-parties, including advertisers,
            ad networks and servers, content providers, and application
            providers. These third parties may use cookies alone or in
            conjunction with web beacons or other tracking technologies to
            collect information about you when you use our Services. The
            information they collect may be associated with your personal
            information or they may collect information, including personal
            information, about your online activities over time and across
            different websites and other online services. They may use this
            information to provide you with interest-based (behavioural)
            advertising or other targeted content.
          </p>
          <p className="py-2">
            You can opt-out of several third party ad servers’ and networks’
            cookies simultaneously by using an opt-out tool created by the
            Digital Advertising Alliance of Canada. You can also access these
            websites to learn more about online behavioural advertising and how
            to stop websites from placing cookies on your device. Opting out of
            a network does not mean you will no longer receive online
            advertising. It does mean that the network from which you opted out
            will no longer deliver ads tailored to your web preferences and
            usage patterns.
          </p>
          <p className="py-2">
            We do not control these third parties’ tracking technologies or how
            they are used. If you have any questions about an advertisement or
            other targeted content, you should contact the responsible provider
            directly.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>HOW WE USE YOUR INFORMATION</strong>
          </h4>
          <p className="py-2">
            We use information that we collect about you or that you provide to
            us,
            <br />
            including any personal information:
          </p>
          <ul className="mt-4 mb-4">
            <li className="ml-4">
              {" "}
              - To present our Services and its contents to you.
            </li>
            <li className="ml-4">
              {" "}
              - To provide you with information, products, or services that you
              request from us.
            </li>
            <li className="ml-4">
              {" "}
              - To fulfill the purposes for which you provided the information
              or that were described when it was collected, or any other purpose
              for which you provide it.
            </li>
            <li className="ml-4">
              {" "}
              - To provide you with notices about your account
            </li>
            <li className="ml-4">
              {" "}
              - To carry out our obligations and enforce our rights arising from
              any contracts with you, including for billing and collection or to
              comply with legal requirements.
            </li>
            <li className="ml-4">
              {" "}
              - To notify you about changes to our Services or any products or
              services we offer or provide though it.
            </li>
            <li className="ml-4">
              {" "}
              - To improve our Services, marketing, or customer relationships
              and experiences.
            </li>
            <li className="ml-4">
              {" "}
              - To allow you to participate in interactive features, social
              media, or similar features through our Services.
            </li>
            <li className="ml-4">
              {" "}
              - To measure or understand the effectiveness of the advertising we
              serve to you and others, and to deliver relevant advertising to
              you.
            </li>
            <li className="ml-4">
              {" "}
              - In any other way we may describe when you provide the
              information.
            </li>
            <li className="ml-4">
              {" "}
              - For any other purpose with your consent. We may use the
              information we have collected from you to enable us to display
              advertisements to our advertisers’ target audiences. Even though
              we do not disclose your personal information for these purposes
              without your consent, if you click on or otherwise interact with
              an advertisement, the advertiser may assume that you meet its
              target criteria.
            </li>
          </ul>
          <h4 className="mt-6 mb-4">
            <strong>DISCLOSURE OF YOUR INFORMATION</strong>
          </h4>
          <p className="py-2">
            We may disclose personal information that we collect or you provide
            as described in this privacy policy:
          </p>
          <ul className="mt-4 mb-4">
            <li className="ml-4">
              {" "}
              - To our subsidiaries and affiliates. In accordance with
              applicable law, to a buyer or other successor in the event of a
              merger, divestiture, restructuring, reorganization, dissolution,
              or other sale or transfer of some or all of Company’s assets,
              whether as a going concern or as part of bankruptcy, liquidation,
              or similar proceeding, in which personal information held by
              Company about our customers and users is among the assets
              transferred.
            </li>
            <li className="ml-4">
              {" "}
              - To advertisers and advertising networks that require the
              information to select and serve relevant advertisements to you and
              others. We do not disclose data about identifiable individuals to
              our advertisers, but we may provide them with aggregate
              information about our users (for example, we may inform them that
              400 women between 30 and 45 have clicked on their advertisement on
              a specific day). We may also use such aggregate information to
              help advertisers target a specific audience (for example, men in a
              specific location). We may make use of the personal information we
              have collected from you to enable us to display our advertisers’
              advertisement to that target audience.
            </li>
            <li className="ml-4">
              {" "}
              - To contractors, service providers, and other third parties we
              use to support our business (such as analytics and search engine
              providers that assist us with improvement and optimization of the
              Services) and who are contractually obligated to keep personal
              information confidential, use it only for the purposes for which
              we disclose it to them, and to process the personal information
              with the same standards set out in this policy.
            </li>
            <li className="ml-4">
              {" "}
              - To fulfill the purpose for which you provide it.
            </li>
            <li className="ml-4">
              {" "}
              - For any other purpose disclosed by us when you provide the
              information.
            </li>
            <li className="ml-4">
              {" "}
              - With your consent.We may also disclose your personal
              information:
            </li>
            <li className="ml-4">
              {" "}
              - To comply with any court order, law, or legal process, including
              to respond to any government or regulatory request, in accordance
              with applicable law.
            </li>
            <li className="ml-4">
              {" "}
              - To enforce or apply our{" "}
              <a href="https://prepitapp.com/terms-and-conditions">
                Terms of Service{" "}
              </a>
              and other agreements, including for billing and collection
              purposes.
            </li>
            <li className="ml-4">
              {" "}
              - If we believe disclosure is necessary or appropriate to protect
              the rights, property, or safety of Company, our customers, or
              others.
            </li>
          </ul>
          <h4 className="mt-6 mb-4">
            <strong>TRANSFERRING YOUR PERSONAL INFORMATION</strong>
          </h4>
          <p className="py-2">
            We may transfer personal information that we collect or that you
            provide as described in this policy to contractors, service
            providers, and other third parties we use to support our business
            (such as analytics and search engine providers that assist us with
            improvement and optimization of the Services) and who are
            contractually obligated to keep personal information confidential,
            use it only for the purposes for which we disclose it to them, and
            to process the personal information with the same standards set out
            in this policy.
          </p>
          <p className="py-2">
            We may process, store, and transfer your personal information in and
            to a foreign country, with different privacy laws that may or may
            not be as comprehensive as Canadian law. In these circumstances, the
            governments, courts, law enforcement, or regulatory agencies of that
            country may be able to obtain access to your personal information
            through the laws of the foreign country. Whenever we engage a
            service provider, we require that its privacy and security standards
            adhere to this policy and applicable Canadian privacy legislation.
          </p>
          <p className="py-2">
            By submitting your personal information or engaging with the
            Services, you consent to this transfer, storage, or processing.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>
              CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION
            </strong>
          </h4>
          <p className="py-2">
            We strive to provide you with choices regarding the personal
            information you provide to us. We have created mechanisms to provide
            you with the following control over your information:
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Tracking Technologies and Advertising.</strong>
          </h4>
          <p className="py-2">
            You can set your browser to refuse all or some browser cookies, or
            to alert you when cookies are being sent. To learn how you can
            manage your Flash cookie settings, visit the Flash player settings
            page on Adobe’s website. If you disable or refuse cookies, please
            note that some parts of this Website may not be accessible or may
            not function properly.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Third-Party Advertising.</strong>
          </h4>
          <p className="py-2">
            If you do not want us to share your personal information with
            unaffiliated or non-agent third parties for promotional purposes,
            you can opt-out by sending us an email at
            <br />
            <a href="https://web.archive.org/web/20241102142214/mailto:info@prepitapp.com">
              info@prepitapp.com.
            </a>
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Promotional Offers from the Company.</strong>
          </h4>
          <p className="py-2">
            If you have opted in to receive certain emails from us but no longer
            wish to have your email address used by the Company to promote our
            own or third parties’ products or services, you can opt-out by
            sending us an email stating your request to{" "}
            <a href="https://web.archive.org/web/20241102142214/mailto:info@prepitapp.com">
              info@prepitapp.com.
            </a>{" "}
            If we have sent you a promotional email, you may unsubscribe by
            clicking the unsubscribe link we have included in the email.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>Targeted Advertising.</strong>
          </h4>
          <p className="py-2">
            If you do not want us to use information that we collect or that you
            provide to us to deliver advertisements according to our
            advertisers’ target-audience preferences, you can opt out by:
          </p>
          <p className="py-2">
            by logging into the Website and adjusting your user preferences in
            your account profile settings by checking or unchecking the relevant
            boxes, or by sending us an email request to info@prepitapp.com; or
            For SMS messages, by replying “STOP” for the SMS sent.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>DATA SECURITY</strong>
          </h4>
          <p className="py-2">
            The security of your personal information is very important to us.
            We use physical, electronic, and administrative measures designed to
            secure your personal information from accidental loss and from
            unauthorized access, use, alteration, and disclosure. We store all
            information you provide to us behind firewalls on our secure
            servers. Any payment transactions will be encrypted.
          </p>
          <p className="py-2">
            The safety and security of your information also depends on you.
            Where we have given you (or where you have chosen) a password for
            access to certain parts of our Services, you are responsible for
            keeping this password confidential. We ask you not to share your
            password with anyone.
          </p>
          <p className="py-2">
            Unfortunately, the transmission of information via the Internet is
            not completely secure. Although we do our best to protect your
            personal information, we cannot guarantee the security of your
            personal information transmitted to our Services. Any transmission
            of personal information is at your own risk. We are not responsible
            for circumvention of any privacy settings or security measures
            contained on the Website.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>DATA RETENTION</strong>
          </h4>
          <p className="py-2">
            Except as otherwise permitted or required by applicable law or
            regulation, we will only retain your personal information for as
            long as necessary to fulfill the purposes we collected it for,
            including for the purposes of satisfying any legal, accounting, or
            reporting requirements. Under some circumstances we may anonymize
            your personal information so that it can no longer be associated
            with you. We reserve the right to use such anonymous and
            de-identified data for any legitimate business purpose without
            further notice to you or your consent.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>CHILDREN UNDER THE AGE OF 13</strong>
          </h4>
          <p className="py-2">
            Our Services is not intended for children under 13 years of age. No
            one under age 13 may provide any personal information to or on the
            Services. We do not knowingly collect personal information from
            children under 13. If you are under 13, do not use or register for
            the Services, make any purchases through the Services, use any of
            the interactive or public comment features of the Services, or
            provide any information about yourself to us, including your name,
            address, telephone number, email address, or any screen name or user
            name you may use. If we learn we have collected or received personal
            information from a child under 13 without verification of parental
            consent, we will delete that information. If you believe we might
            have any information from or about a child under 13,
            <br />
            please contact us at
            <br />
            <a href="https://web.archive.org/web/20241102142214/mailto:info@prepitapp.com">
              info@prepitapp.com.
            </a>
          </p>
          <h4 className="mt-6 mb-4">
            <strong>ACCESSING AND CORRECTING YOUR PERSONAL INFORMATION</strong>
          </h4>
          <p className="py-2">
            It is important that the personal information we hold about you is
            accurate and current. Please keep us informed if your personal
            information changes. By law you have the right to request access to
            and to correct the personal information that we hold about you.
          </p>
          <p className="py-2">
            If you want to review, verify, correct, or withdraw consent to the
            use of your personal information you may also send us an email at
            info@prepitapp.com to request access to, correct, or delete any
            personal information that you have provided to us. We may not
            accommodate a request to change information if we believe the change
            would violate any law or legal requirement or cause the information
            to be incorrect.
          </p>
          <p className="py-2">
            We may request specific information from you to help us confirm your
            identity and your right to access, and to provide you with the
            personal information that we hold about you or make your requested
            changes. Applicable law may allow or require us to refuse to provide
            you with access to some or all of the personal information that we
            hold about you, or we may have destroyed, erased, or made your
            personal information anonymous in accordance with our record
            retention obligations and practices. If we cannot provide you with
            access to your personal information, we will inform you of the
            reasons why, subject to any legal or regulatory restrictions.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>WITHDRAWING YOUR CONSENT</strong>
          </h4>
          <p className="py-2">
            Where you have provided your consent to the collection, use, and
            transfer of your personal information, you may have the legal right
            to withdraw your consent under certain circumstances. To withdraw
            your consent, if applicable, contact us at{" "}
            <a href="https://web.archive.org/web/20241102142214/mailto:info@prepitapp.com">
              info@prepitapp.com.
            </a>{" "}
            Please note that if you withdraw your consent we may not be able to
            provide you with a particular product or service. We will explain
            the impact to you at the time to help you with your decision.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>CHANGES TO OUR PRIVACY POLICY</strong>
          </h4>
          <p className="py-2">
            It is our policy to post any changes we make to our privacy policy
            on this page. If we make material changes to how we treat our users’
            personal information, we will notify you by email to the email
            address specified in your account or through a notice on the Website
            or App.
          </p>
          <p className="py-2">
            We include the date the privacy policy was last revised at the top
            of the page. You are responsible for ensuring we have an up-to-date,
            active, and deliverable email address for you, and for periodically
            visiting our Website and this privacy policy to check for any
            changes.
          </p>
          <h4 className="mt-6 mb-4">
            <strong>CONTACT INFORMATION AND CHALLENGING COMPLIANCE</strong>
          </h4>
          <p className="py-2">
            We welcome your questions, comments, and requests regarding this
            privacy policy and our privacy practices. Please contact us at:
          </p>
          <p className="py-2">Privacy Officer</p>
          <p className="py-2">
            <a href="https://web.archive.org/web/20241102142214/https://www.google.com/maps/place/65+Gloucester+St,+Toronto,+ON+M4Y+1L8,+Canada/@43.6670416,-79.3842555,17z/data=!3m1!4b1!4m5!3m4!1s0x882b34b2949b8bc5:0xbdeb3ab78cd1aa1c!8m2!3d43.6670416!4d-79.3820668">
              65 Gloucester St., Toronto, ON
            </a>{" "}
            <br />
            or <br />
            <a href="https://web.archive.org/web/20241102142214/mailto:info@prepitapp.com">
              info@prepitapp.com.
            </a>
          </p>
          <p className="py-2">
            We have procedures in place to receive and respond to complaints or
            inquiries about our handling of personal information, our compliance
            with this policy, and with applicable privacy laws. To discuss our
            compliance with this policy please contact our Privacy Officer using
            the contact information listed above.
          </p>
        </>
      </div>
    </div>
  );
}

export default Index;
